module.exports = {
      id: "premium-usage",
      viewBox: "0 0 576 512",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#premium",
      toString: function () {
        return this.url;
      }
    }